module.exports = __webpack_public_path__ + "img/bg_festa6.04615bd5.jpg";